import React from 'react';
import CookieConsent from "react-cookie-consent";
import Impressum from './impressum'
import Landing from './landing'
import Contact from './contact'
import Collections from './collections'
import Highlights from './highlights'
import Neuheiten from './neuheiten'
import Lightbox from './lightbox'
import Events from './events'
import News from './news'
import DataProtection from './dataprotection'
import { ADMIN_PATH, navigate } from '../lib/router'
import { MOBILE_QUERY, observeLayout } from '../lib/layout'
import { enableAnalytics } from '../lib/analytics'
import { applyDesign, clearDesign, subscribeDesign } from '../lib/design'
import { subscribeGallery } from '../lib/gallery'

class Home extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            selectedmenu: "home",
            // Bildschirmbreite statt Seitenverhältnis: ein quer gehaltenes
            // Handy bekam sonst das Desktop-Layout.
            mode: window.matchMedia(MOBILE_QUERY).matches ? "mobile" : "web",
            menuopen: false,
            // Ohne Bilder erscheint 'Neuheiten' gar nicht erst im Menü.
            neuheiten: false,
            lightbox: null, // { src, alt } solange ein Bild gross gezeigt wird
        }
    }

    componentDidMount() {
        var that = this;
        // Die im Admin gesetzte Hintergrundfarbe gilt nur fuer die Website; der
        // Admin-Bereich bleibt weiss, deshalb hier und nicht in App.js.
        this.disposeDesign = subscribeDesign(applyDesign);
        this.unsubscribeGallery = subscribeGallery(function (gallery) {
            var vorhanden = gallery.neuheiten.items.length > 0;
            that.setState(function (vorher) {
                return {
                    neuheiten: vorhanden,
                    // Wird die letzte Neuheit entfernt, waehrend die Seite
                    // offen ist, bleibt sonst eine leere Ansicht stehen.
                    selectedmenu: !vorhanden && vorher.selectedmenu === 'neuheiten'
                        ? 'home'
                        : vorher.selectedmenu
                };
            });
        });
        this.disposeLayout = observeLayout(function (mode) {
            // Beim Wechsel auf das Desktop-Layout darf kein aufgeklapptes
            // Mobilmenü zurückbleiben.
            that.setState({ mode: mode, menuopen: false });
        });
    }

    componentWillUnmount() {
        if (this.disposeLayout) {
            this.disposeLayout();
        }
        if (this.disposeDesign) {
            this.disposeDesign();
        }
        if (this.unsubscribeGallery) {
            this.unsubscribeGallery();
        }
        clearDesign();
    }

    menukeytocaption(key) {
        var assignment = {
            "home": "",
            "neuheiten": "Neuheiten",
            "schmuck": "Schmuckstücke",
            //"highlights": "Highlights",
            //"events": "Events",
            //"news": "Kontakt",
            "contac": "Kontakt"
        }
        return assignment[key];
    }



    changeContent = (index) => {
        this.setState({
            selectedmenu: index,
            menuopen: false
        });
    };

    // Ein Klick auf ein Inhaltsbild zeigt es gross. Die Pruefung laeuft ueber
    // das angeklickte Element, damit nicht jede Komponente einzeln einen
    // Handler braucht — Logo, Menuebilder und Kategoriekacheln bleiben so
    // aussen vor, sie fuehren woandershin.
    bildAnklicken = (event) => {
        var ziel = event.target;
        if (ziel.tagName !== 'IMG') {
            return;
        }
        if (!ziel.classList.contains('smallimage') && !ziel.classList.contains('bigimage')) {
            return;
        }
        // Alle Bilder der aktuellen Ansicht mitgeben, damit sich in der
        // Grossansicht durchblaettern laesst. Die Reihenfolge ist die des
        // Dokuments, also genau die sichtbare.
        var knoten = Array.prototype.slice.call(
            event.currentTarget.querySelectorAll('img.smallimage, img.bigimage')
        );
        var index = knoten.indexOf(ziel);
        if (index < 0) {
            return;
        }
        var bilder = knoten.map(function (bild) {
            return { src: bild.currentSrc || bild.src, alt: bild.alt };
        });
        this.setState({ lightbox: { bilder: bilder, index: index } });
    };

    toggleMenu() {
        this.setState(function (prev) {
            return { menuopen: !prev.menuopen };
        });
    }

    render() {

        var header = this.createHeader();
        var menu = this.createMenu();
        var content = (<div></div>);
        var prefooter = this.createPrefooter();
        var footer = this.createFooter();
        var cookies = this.createCookieConsent();
        if (this.state.selectedmenu === 'home') {
            content = <Landing />
        }
        if (this.state.selectedmenu === 'impressum') {
            content = <Impressum />
        }
        if (this.state.selectedmenu === 'dataprotection') {
            content = <DataProtection />
        }
        if (this.state.selectedmenu === 'schmuck') {
            content = <Collections />
        }
        if (this.state.selectedmenu === 'highlights') {
            content = <Highlights />
        }
        if (this.state.selectedmenu === 'neuheiten') {
            content = <Neuheiten />
        }
        if (this.state.selectedmenu === 'events') {
            content = <Events />
        }
        if (this.state.selectedmenu === 'news') {
            content = <News />
        }
        if (this.state.selectedmenu === 'contact') {
            content = <Contact />
        }

        return (
            <div class='fullwidth fullheight floatrelative'>
                {header}
                {menu}
                <main class='mainarea' onClick={this.bildAnklicken}>
                    {content}
                </main>
                {this.state.lightbox && (
                    <Lightbox
                        bilder={this.state.lightbox.bilder}
                        index={this.state.lightbox.index}
                        onIndex={(index) => this.setState(function (vorher) {
                            return { lightbox: { bilder: vorher.lightbox.bilder, index: index } };
                        })}
                        onClose={() => this.setState({ lightbox: null })}
                    />
                )}
                {prefooter}
                {footer}
                {cookies}
            </div >
        );
    }

    createHeader() {
        return (<header class='fixedheader'>
            <div class='fullwidthcontainer'>
                {/* Einzige h1 der Seite: der Name des Hauses. Die Klasse setzt
                    die Standardabstände der Überschrift zurück, damit die
                    Kopfhöhe unverändert bleibt. */}
                <h1 class='brandheading'>
                    <button type='button' class='logobutton' aria-label='Zur Startseite' onClick={() => this.changeContent('home')}>
                        <img src="./assets/logo_wide.webp" alt="Augenstern Schmuck" class='centeredlogo' />
                    </button>
                </h1>
            </div>
        </header>)
    }

    createMenu() {
        if (this.state.mode === 'web') {

            return (<nav class='fixedmenu' aria-label='Hauptmen&uuml;'>
                <div class='fullwidthcontainer'>
                    <div class='centercontainer'>
                        {this.state.neuheiten && (
                            <button type='button' class={this.state.selectedmenu === 'neuheiten' ? 'menuitem-selected' : 'menuitem'} onClick={() => this.changeContent('neuheiten')}>Neuheiten</button>
                        )}
                        <button type='button' class={this.state.selectedmenu === 'schmuck' ? 'menuitem-selected' : 'menuitem'} onClick={() => this.changeContent('schmuck')}>Schmuckst&uuml;cke</button>
                        <button type='button' class={this.state.selectedmenu === 'highlights' ? 'menuitem-selected' : 'menuitem'} onClick={() => this.changeContent('highlights')}>Highlights</button>
                        <button type='button' class={this.state.selectedmenu === 'contact' ? 'menuitem-selected' : 'menuitem'} onClick={() => this.changeContent('contact')}>Kontakt</button>
                    </div>
                </div>
            </nav>)
        }

        return (
            <nav aria-label='Hauptmen&uuml;'>
                <div class='fixedmenu'>
                    <div class='floatrelative menuitem center'>
                        {this.menukeytocaption(this.state.selectedmenu)}
                    </div>
                    <button
                        type='button'
                        class='menuicon'
                        aria-label='Men&uuml; &ouml;ffnen'
                        aria-expanded={this.state.menuopen}
                        aria-controls='togglemenu'
                        onClick={() => this.toggleMenu()}>
                        <img src="./assets/menu-burger.png" alt="" class='menuicon-image' />
                    </button>
                </div>
                <div class={this.state.menuopen ? 'fixedmenu-sub fixedmenu-sub-open' : 'fixedmenu-sub'} id='togglemenu'>
                    <div class='fullwidthcontainer'>
                        {this.state.neuheiten && (
                            <button type='button' class='fullwidthcontainer menuitem center' onClick={() => this.changeContent('neuheiten')}>Neuheiten</button>
                        )}
                        <button type='button' class='fullwidthcontainer menuitem center' onClick={() => this.changeContent('schmuck')}>Schmuckst&uuml;cke</button>
                        <button type='button' class='fullwidthcontainer menuitem center' onClick={() => this.changeContent('highlights')}>Highlights</button>
                        <button type='button' class='fullwidthcontainer menuitem center' onClick={() => this.changeContent('contact')}>Kontakt</button>
                    </div>
                </div>
            </nav>
        )
    }

    createPrefooter() {
        return (<div class='prefooter'>
            <div class='fullwidthcontainer'>
                <img src="./assets/logo_wide.webp" alt="" class='centeredlogo' />
            </div>
            <div class='fullwidthcontainer'>
                <div class='halfwidthcontainer'>
                    <h2 class='header1'>Augenstern Schmuck e.K.</h2>
                    <div class='text'>
                        Alexandra Gabriele Faltermeier <br />
                        Telefon: (+49) 151 11198897
                    </div>
                </div>
                <div class='halfwidthcontainer'>
                    <h2 class='header1'>Showroom</h2>
                    <div class='text'>
                        Stadtgraben 32<br />
                        94315 Straubing<br />
                    </div>
                    <h3 class='header2'>Öffnungszeiten</h3>
                    <div class='text'>
                        Donnerstag &amp; Freitag 10:00 - 17:00 Uhr<br />
                        und nach Vereinbarung
                    </div>
                </div>
            </div>
        </div>);
    }

    createFooter() {
        return (<footer class='footer'>
            <div class='footermenu'>
                <button type='button' class='footermenuitem' onClick={() => this.changeContent('impressum')}>Impressum</button>
                <button type='button' class='footermenuitem' onClick={() => this.changeContent('dataprotection')}>Datenschutz</button>
            </div>
            <div class='footercopyright'>
                2026 © Augenstern Schmuck e.K.
            </div>
            <button type='button' class='footeradmin' title='Administration' aria-label='Administration' onClick={() => navigate(ADMIN_PATH)}>
                {/* Zahnrad als Inline-SVG statt PNG, damit es die Schriftfarbe
                    des Footers erbt und keine weitere Bilddatei nötig ist. */}
                <svg viewBox='0 0 24 24' width='20' height='20' aria-hidden='true' focusable='false'>
                    <path fill='currentColor' d='M19.14 12.94a7.5 7.5 0 0 0 .05-1.88l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.6-.22l-2.39.96a7.3 7.3 0 0 0-1.63-.94l-.36-2.54a.5.5 0 0 0-.5-.42h-3.84a.5.5 0 0 0-.5.42l-.36 2.54c-.59.24-1.13.56-1.63.94l-2.39-.96a.5.5 0 0 0-.6.22L2.7 8.84a.5.5 0 0 0 .12.64l2.03 1.58a7.5 7.5 0 0 0 0 1.88L2.82 14.5a.5.5 0 0 0-.12.64l1.92 3.32c.12.21.37.3.6.22l2.39-.96c.5.38 1.04.7 1.63.94l.36 2.54c.04.24.25.42.5.42h3.84c.25 0 .46-.18.5-.42l.36-2.54c.59-.24 1.13-.56 1.63-.94l2.39.96c.23.08.48-.01.6-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58ZM12 15.5A3.5 3.5 0 1 1 12 8.5a3.5 3.5 0 0 1 0 7Z' />
                </svg>
            </button>
        </footer>);
    }

    createCookieConsent() {
        // Ohne Overlay: Die Seite bleibt lesbar, während entschieden wird.
        // Analytics startet erst bei Zustimmung — vorher lief die Messung
        // unabhängig davon, was hier geklickt wurde.
        return (<CookieConsent
            location="bottom"
            buttonText="Akzeptieren"
            enableDeclineButton
            declineButtonText="Ablehnen"
            cookieName="AugensternCookieConsent"
            style={{ background: "#000000", fontSize: "16px", fontFamily: "Garamond", alignItems: "center" }}
            buttonStyle={{ background: "#FFFFFF", color: "#000000", fontSize: "16px", borderRadius: "25px", padding: "12px 24px" }}
            declineButtonStyle={{ background: "none", color: "#FFFFFF", fontSize: "16px", border: "1px solid #FFFFFF", borderRadius: "25px", padding: "12px 24px" }}
            expires={365}
            debug={false}
            onAccept={() => enableAnalytics()}
        >
            Wir verwenden Cookies zur Reichweitenmessung mit Google Analytics. Sie k&ouml;nnen die
            Seite auch ohne diese Messung nutzen.{" "}
        </CookieConsent>);
    }
}


export default (Home);
